import Enumerator from '../global/Enumerator';

export const reportStatusTypes = [
  'CREATED',
  'PAUSED',
  'STALE',
  'LODGED',
  'SUBMITTED',
  'CONDITIONALLY_APPROVED',
  'APPROVED',
  'SETTLED',
  'WON',
  'WITHDRAWN',
  'DECLINED',
  'LOST'
];

export class ReportStatusType extends Enumerator {
  static default() {
    return this.of('CREATED');
  }
}
ReportStatusType.initEnum({
  CREATED: {
    get term() {
      return 'Created';
    },
    get path() {
      return undefined;
    },
    get prop() {
      return 'isActive';
    },
    get propTime() {
      return 'timeStamp';
    },
    get propBase() {
      return 'isActive';
    },
    get propBaseTime() {
      return 'timeStamp';
    }
  },
  EXPECTED: {
    get term() {
      return 'Expected';
    },
    get path() {
      return undefined;
    },
    get prop() {
      return 'isActive';
    },
    get propTime() {
      return 'values.onceOffDueDate';
    },
    get propBase() {
      return 'isActive';
    },
    get propBaseTime() {
      return 'values.onceOffDueDate';
    }
  },
  PAUSED: {
    get term() {
      return 'Paused';
    },
    get path() {
      return 'relStatusHistory';
    },
    get prop() {
      return 'relStatusHistory.isFrozen';
    },
    get propTime() {
      return 'relStatusHistory.timeStamp';
    },
    get propBase() {
      return 'isFrozen';
    },
    get propBaseTime() {
      return 'frozenTimeStamp';
    }
  },
  STALE: {
    get term() {
      return 'Stale';
    },
    get path() {
      return 'relStatusHistory';
    },
    get prop() {
      return 'relStatusHistory.isRotten';
    },
    get propTime() {
      return 'relStatusHistory.timeStamp';
    },
    get propBase() {
      return 'isRotten';
    },
    get propBaseTime() {
      return 'rottenTimeStamp';
    }
  },
  LODGED: {
    get term() {
      return 'Lodged';
    },
    get path() {
      return 'relStatusHistory';
    },
    get prop() {
      return 'relStatusHistory.isLodged';
    },
    get propTime() {
      return 'relStatusHistory.timeStamp';
    },
    get propBase() {
      return 'isLodged';
    },
    get propBaseTime() {
      return 'lodgedTimeStamp';
    }
  },
  SUBMITTED: {
    get term() {
      return 'Submitted';
    },
    get path() {
      return 'relStatusHistory';
    },
    get prop() {
      return 'relStatusHistory.isSubmitted';
    },
    get propTime() {
      return 'relStatusHistory.timeStamp';
    },
    get propBase() {
      return 'isSubmitted';
    },
    get propBaseTime() {
      return 'submittedTimeStamp';
    }
  },
  CONDITIONALLY_APPROVED: {
    get term() {
      return 'ConditionallyApproved';
    },
    get path() {
      return 'relStatusHistory';
    },
    get prop() {
      return 'relStatusHistory.isConditionallyApproved';
    },
    get propTime() {
      return 'relStatusHistory.timeStamp';
    },
    get propBase() {
      return 'isConditionallyApproved';
    },
    get propTimeBase() {
      return 'conditionallyApprovedTimeStamp';
    }
  },
  APPROVED: {
    get term() {
      return 'Approved';
    },
    get path() {
      return 'relStatusHistory';
    },
    get prop() {
      return 'relStatusHistory.isApproved';
    },
    get propTime() {
      return 'relStatusHistory.timeStamp';
    },
    get propBase() {
      return 'isApproved';
    },
    get propBaseTime() {
      return 'approvedTimeStamp';
    }
  },
  SETTLED: {
    get term() {
      return 'Settled';
    },
    get path() {
      return 'relStatusHistory';
    },
    get prop() {
      return 'relStatusHistory.isSettled';
    },
    get propTime() {
      return 'relStatusHistory.timeStamp';
    },
    get propBase() {
      return 'isSettled';
    },
    get propBaseTime() {
      return 'settledTimeStamp';
    }
  },
  WON: {
    get term() {
      return 'Won';
    },
    get path() {
      return 'relStatusHistory';
    },
    get prop() {
      return 'relStatusHistory.isWon';
    },
    get propTime() {
      return 'relStatusHistory.timeStamp';
    },
    get propBase() {
      return 'isWon';
    },
    get propBaseTime() {
      return 'wonTimeStamp';
    }
  },
  WITHDRAWN: {
    get term() {
      return 'WithDrawn';
    },
    get path() {
      return 'relStatusHistory';
    },
    get prop() {
      return 'relStatusHistory.isWithDrawn';
    },
    get propTime() {
      return 'relStatusHistory.timeStamp';
    },
    get propBase() {
      return 'isWithDrawn';
    },
    get propBaseTime() {
      return 'withDrawnTimeStamp';
    }
  },
  DECLINED: {
    get term() {
      return 'Declined';
    },
    get path() {
      return 'relStatusHistory';
    },
    get prop() {
      return 'relStatusHistory.isDeclined';
    },
    get propTime() {
      return 'relStatusHistory.timeStamp';
    },
    get propBase() {
      return 'isDeclined';
    },
    get propBaseTime() {
      return 'declinedTimeStamp';
    }
  },
  LOST: {
    get term() {
      return 'Lost';
    },
    get path() {
      return 'relStatusHistory';
    },
    get prop() {
      return 'relStatusHistory.isLost';
    },
    get propTime() {
      return 'relStatusHistory.timeStamp';
    },
    get propBase() {
      return 'isLost';
    },
    get propBaseTime() {
      return 'lostTimeStamp';
    }
  }
});

export default {
  reportStatusTypes,
  ReportStatusType
};
